import BottomSheet from './bottom-sheet';
import AppPicker from './app-picker';
import Tip from './tip';
import TextInput from './text-input';
BottomSheet.AppPicker = AppPicker;
BottomSheet.Tip = Tip;
BottomSheet.TextInput = TextInput;
export default BottomSheet;
//# sourceMappingURL=index.js.map